<template>
  <div>
    <HeaderReceipt header="การเพิ่มสินค้าเข้าคลัง" :img_header="header_image" link_back="stock/storage/mainstorage"/>
    <AddProduct_ToStock/>
  </div>
</template>

<script>
import HeaderReceipt from "@/components/admin/stock/menustorage/HeaderReceipt";
import HeaderImage from "@/assets/completed-task.png";
import AddProduct_ToStock from "@/components/admin/stock/storage/AddProduct_ToStock";
export default {
  name: "AddProductToStock",
  data() {
    return {
      header_image: HeaderImage
    }
  },
  components: {
    AddProduct_ToStock,
    HeaderReceipt,
  }
}
</script>

<style scoped>

</style>
